<template>
  <div>
    <div id="chart-container" class="by-value">
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="cp-by-emotional-value-e-chart" class="chart-row">
        <profile-chart-header
        :title="'Match Driver Profile | ' + titleSuffix"
        :content-list="contentList"
        :content-name="'Match Driver Profile'"
        :display="this.$parent.getDisplayView() && getDisplayView()"
        :input-display-number-of-responses="displayNumberOfResponses"
        :input-show-tooltip="showTooltip"
        @set-display-number-of-responses="setDisplayNumberOfResponsesForValueComponents"
        @set-show-tooltip="setShowTooltipForValueComponents"
        />                  
        <profile-chart ref="eChartValueDriver"
              :e-chart-mini-id="'profile-match-value-driver-chart-mini'"
              :e-chart-id="'profile-match-value-driver-chart'"
              :input-report-type-name="'Chart - Match Value Drivers'"
              :modal-id="'value-drivers-chart'"
              :is-saved-card="$parent.clientChart.clientChartId != 0" 
              :input-client-chart="this.$parent.clientChart"
              :inputDownloadFileName="'Match Emotional Drivers - ' + titleSuffix"
              @save-table="saveProfileDataTable"
              @save-criteria="buildClientChart"/>        
      </div>
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="cp-by-functional-value-e-chart" class="chart-row">
        <profile-chart ref="eChartValueComponents"
            :e-chart-mini-id="'profile-match-value-chart-mini'"
            :e-chart-id="'profile-match-value-chart'"
            :input-report-type-name="'Chart - Match Value Components'"
            :modal-id="'value-components-chart'"
            :is-saved-card="$parent.clientChart.clientChartId != 0" 
            :input-client-chart="this.$parent.clientChart"
            :inputDownloadFileName="'Match Functional Drivers - ' + titleSuffix"
            @save-table="saveProfileDataTable"
            @save-criteria="buildClientChart"/>        
      </div>
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="valueFunctionalTable.tableContainerId" :class="isInsiderUser ? 'chart-data hide-table-data' : 'chart-data'">
        <div v-show="isInsiderUser" class="overlay">
            <img class="overlay-inner" v-show="isInsiderUser" src="../../../assets/img/overlap.png" style="width: 490px"/>
        </div>
        <chart-data-table
          ref="functionalDataTable"
          v-show="this.$parent.getDisplayView() && getDisplayView()"
          :chart-data="this.valueFunctionalTable.data"
          :display-direction="'vertical'"
          :data-container-id="valueFunctionalTable.tableContainerId"
          :container-id="'profile_match_by_value_functional_chart'"
          :column-defs="this.chart.columnDefsFunctional"
          :is-saved-card="$parent.clientChart.clientChartId != 0" 
          :table-class="'table display responsive row-border table-hover'"
          :table-width="'auto'"
          :table-title="this.valueFunctionalTable.title"
          :report-page-type-name="'Table - Match Value Components'"
          :insight-modal-id="'value-components-table'"
          :content-list="this.contentList"
          :inputDownloadFileName="'Match Driver Profile - ' + titleSuffix"
          :effort-list="functionalEffortList"
          :use-alternate-title="true"
          @display-initiatives="$parent.displayInitiativesForProfileTable"
          @go-to-explore="$parent.goToExploreForProfileTable"
        ></chart-data-table>
      </div>
    </div>
    
    <insights
      ref="insightsFunctionalChart"
      :modal-name="'value-components-chart'"
      :report-page-type-name="'Chart - Match Value Components'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsFunctionalTable"
      :modal-name="'value-components-table'"
      :report-page-type-name="'Table - Match Value Components'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsEmotionalChart"
      :modal-name="'value-drivers-chart'"
      :report-page-type-name="'Chart - Match Value Drivers'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ProfileChart from "../../../views/echarts/ProfileChart.vue";
import ProfileChartHeader from "../../../components/echarts/ProfileChartHeader.vue";
import ProfileService from "../../../services/echarts/profile.service";

import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import NeedsService from "../../../services/needs.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";

export default {
  name: "MatchByValue",
  mixins: [ChartCompanyMixins],
  components: {  ProfileChart, ProfileChartHeader},
  data() {
    return {
      displayNumberOfResponses: false,
      showTooltip:true,
      displayType: "match-value",
      eChartDataForValueDriver: {},
      titleSuffix: "",
      functionalEffortList: [],
      emotionalEffortList: [],
      valueFunctionalTable: {
        id: "",
        data: {},
        tableContainerId: "value_functional_needs_data_container",
        title: "<div class='title'><h4 class='text-primary mb-0'>Functional Needs</h4><div class='chart-sub-title'><span>Importance/Satisfaction Gap</span> vs. <span>Willingness to Pay</span></div></div>"
      },
      drivers: [
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        },
        {
          name: "",
          weight: "",
          emotionalNeedName1: "",
          emotionalNeedName2: ""
        }
      ],
    };
  },
  props: {
    chartData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    contentList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    surveyCode: function() {
      return this.$parent.$data.survey.surveyCode;
    },    

  },
  mounted() {
    $.extend(this.$refs.functionalDataTable.configuration, { orderFixed: [[0, "asc"]] });
  },
  created() {},
  methods: {
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Match Value Components") {
        this.$refs.insightsFunctionalChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsFunctionalChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Match Value Components") {
        this.$refs.insightsFunctionalTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsFunctionalTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Chart - Match Value Drivers") {
        this.$refs.insightsEmotionalChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsEmotionalChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } 
    },
    async processChartData() {
      try {
        if (typeof this.eChartCriteria != "undefined" && typeof this.eChartCriteria.displayNumberOfResponses != "undefined") {
          this.displayNumberOfResponses = this.eChartCriteria.displayNumberOfResponses;
        }
        if (typeof this.eChartCriteria != "undefined" && typeof this.eChartCriteria.showTooltip != "undefined") {
          this.showTooltip = this.eChartCriteria.showTooltip;
        }
        this.chart = ChartService.getChartAttributes("Match By Value");
        for (let i = 0; i < this.chartData.length; i++) {
          let needsData = JSON.parse(JSON.stringify(this.chartData[i]));
          let otherData = needsData["otherData"];
          let needsList = otherData["needsList"];
          let driverList = otherData["driverList"];
          let companyColorList = otherData["companyColorList"];

          TableService.setCompanyColorList(companyColorList);
          let containerId = needsData["containerId"];
          this.table.id = containerId;

          if (containerId === "profile_match_by_value_functional_chart") {
            let titleSuffix = otherData["titleSuffix"];
            if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
              this.titleSuffix = titleSuffix;
            }
            needsData.rows = otherData["finalRows"];
            this.functionalEffortList = otherData["effortList"];
            NeedsService.setFunctionalNeedsList(needsList);
            let labelIndex = 3;
            let copyOfChartData = JSON.parse(JSON.stringify(needsData));

            for (let index = 0; index < driverList.length; index++) {
              this.drivers[index].name = driverList[index].name;
              let weight = driverList[index].weight;
              if (weight == null){
                this.drivers[index].weight = " ";
              } else if (weight != null && !isNaN(weight)) {
                let finalWeight = weight * 100;
                this.drivers[index].weight = Number(finalWeight).toFixed(1) + "%";
              } else {
                this.drivers[index].weight = "--";
              }
            }
            for (let indexRows = 0; indexRows < copyOfChartData.rows.length; indexRows++) {
              let copyOfChartDataRow = copyOfChartData.rows[indexRows].c;
              let originalName = copyOfChartDataRow[labelIndex].v;
              if (originalName != null && originalName.includes(",")) {
                let copyValue = copyOfChartDataRow[labelIndex].v.split(",");
                if (typeof copyValue != "undefined") {
                  copyOfChartDataRow[labelIndex].v.trim();
                  copyOfChartDataRow[labelIndex].v = copyValue[0] + " / " + copyValue[1];
                  NeedsService.replaceNeedName(originalName, copyOfChartDataRow[labelIndex].v, "emotional");
                  this.drivers[indexRows].emotionalNeedName1 = copyValue[1];
                  this.drivers[indexRows].emotionalNeedName2 = copyValue[0];
                }
              }
            }
            this.valueFunctionalTable.id = containerId;
            this.valueFunctionalTable.data = JSON.parse(JSON.stringify(copyOfChartData));
            this.$parent.setChartResults(needsData.companyList);
            this.$parent.$data.criteriaResultsList = AdminService.removeByName(needsData.criteriaList, "Competitor");
          } else if (containerId === "profile_match_by_value_emotional_chart") {
            this.emotionalEffortList = otherData["effortList"];
            this.functionalEffortList = this.functionalEffortList.concat(this.emotionalEffortList);
            NeedsService.setEmotionalNeedsList(needsList);
          }
        }
        this.$root.$emit("check-number-of-responses");     
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
        this.setEChartCriteria(this.$parent.$refs.chartCriteria.eChartCriteria);
        this.eChartCriteria.eChartType = "stacked-bar-vertical";        
        this.parseMatchProfileDataForValue(JSON.parse(JSON.stringify(this.chartData)));
        this.$refs.eChartValueComponents.processChart(true,"match-value",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower,this.$parent.$refs.chartCriteria.matchType);

        this.parseMatchProfileDataForValueDriver(JSON.parse(JSON.stringify(this.chartData)));
        let eChartCriteria = JSON.parse(JSON.stringify(this.eChartCriteria));
        eChartCriteria.eChartType = "bar-horizontal";
        this.$refs.eChartValueDriver.processChart(true,"match-value-driver",this.eChartDataForValueDriver,eChartCriteria,false,this.$parent.$refs.chartCriteria.matchType);
        $("#cp-by-emotional-value-e-chart").addClass("chart-wrapper");
        $("#cp-by-functional-value-e-chart").addClass("chart-wrapper");
        
      } catch (err) {
        ErrorService.processException("MatchByValue.displayChartCallback", err, "chart", this);
      }
    },
    setShowTooltipForValueComponents(inputShowTooltip){
      this.eChartCriteria.showTooltip = inputShowTooltip;
      this.$parent.$refs.chartCriteria.eChartCriteria.showTooltip = inputShowTooltip;
      this.$refs.eChartValueComponents.processChart(this.getDisplayView(),"value",this.eChartData,this.eChartCriteria,this.displayPricingPower);
      this.showTooltip = inputShowTooltip;

      let eChartCriteria = JSON.parse(JSON.stringify(this.eChartCriteria));
      eChartCriteria.eChartType = "bar-horizontal";
      this.$refs.eChartValueDriver.processChart(this.getDisplayView(),"value-driver",this.eChartDataForValueDriver,eChartCriteria,false);
    },
    setDisplayNumberOfResponsesForValueComponents(inputDisplayNumberOfResponses){
      this.displayNumberOfResponses = inputDisplayNumberOfResponses;
      this.eChartCriteria.displayNumberOfResponses = inputDisplayNumberOfResponses;
      this.$parent.$refs.chartCriteria.eChartCriteria.displayNumberOfResponses = inputDisplayNumberOfResponses;
      this.$refs.eChartValueComponents.processChart(this.getDisplayView(),"match-value",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower,this.$parent.$refs.chartCriteria.matchType);
      this.displayNumberOfResponses = inputDisplayNumberOfResponses;

      let eChartCriteria = JSON.parse(JSON.stringify(this.eChartCriteria));
      eChartCriteria.eChartType = "bar-horizontal";
      this.$refs.eChartValueDriver.processChart(this.getDisplayView(),"match-value-driver",this.eChartDataForValueDriver,eChartCriteria,false);

    },
    parseMatchProfileDataForValue: function(inputData){
      let itemsToRemove = {
          firstColumns: 3,
          lastRows: 1
      };
        let data = {};
        let chart1Data = inputData[0];
        data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
        data = ProfileService.parseLegendAndColorData(chart1Data,data,false);
        this.eChartData = JSON.parse(JSON.stringify(data));
    },   
    parseMatchProfileDataForValueDriver:function(inputData){
      let itemsToRemove = {
          firstColumns: 3,
          lastRows: 1
        };
        let data = {};
        let chart1Data = inputData[1];
        data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
        data = ProfileService.parseLegendAndColorData(chart1Data,data,false);
        data = ProfileService.parseDriverListData(inputData[0],data);
        this.eChartDataForValueDriver = JSON.parse(JSON.stringify(data));
    },    
    saveProfileDataTable(){
      let vm = this;
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        setTimeout(function() {
            ReportService.saveReportPage(vm.getReportTableContent("profile_match_by_value_functional_chart"), "Table - Match Value Components", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
            ReportService.saveReportPage(vm.getReportTableContent("profile_match_by_value_emotional_chart"), "Table - Match Value Drivers", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
            ReportService.saveReportTableFile(vm.$refs.functionalDataTable.getTableData(), "Table - Value Components", vm.$parent.clientChart, vm.saveReportTableFileCallback, vm);
        }, 1500);    
      }
    },
    saveAllReportPages() {
      this.saveProfileDataTable();
    },

  },
  watch: {
    surveyCode: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.$refs.eChartValueComponents.clear();} catch(e){}
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.$refs.eChartValueDriver.clear();} catch(e){}
    },
    chartData: function() {
      if (this.$parent.$refs.chartCriteria.$data.displayType == "value") {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    },
    eChartCriteria: function() {
      if (typeof this.eChartCriteria != "undefined" && typeof this.eChartCriteria.displayNumberOfResponses != "undefined") {
          this.displayNumberOfResponses = this.eChartCriteria.displayNumberOfResponses;
      }
      if (typeof this.eChartCriteria != "undefined" && typeof this.eChartCriteria.showTooltip != "undefined") {
          this.showTooltip = this.eChartCriteria.showTooltip;
      }
    }
  }
};
</script>
